import { isEmpty } from 'lodash';

export const mapkitSearch = (
  searchInput: string,
  setResults: (e: mapkit.SearchAutocompleteResult[]) => void
): void => {
  try {
    if (isEmpty(searchInput)) {
      setResults([]);
      return;
    }
    const search = new mapkit.Search();
    search.autocomplete(searchInput, (error, data) => {
      if (error) {
        setResults([]);
        return;
      }
      setResults(data.results);
    });
  } catch (e) {
    setResults([]);
  }
  return;
};
